import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  makeStyles,
  TableRow,
  TableCell,
  Button
} from "@material-ui/core";

import IconEstado from "../../../autorizaciones/UI/IconEstado";
import AddButtonComprobante from "../../UI/AddButtonComprobante";
import { liberarProformaMesaEntrada, postComprobanteMesaEntrada, setActiveStepMesaEntrada, tomarProformaMesaEntrada } from "../../../../actions/mesaEntrada/mesaEntradaActions";
import { StepperFormExpediente } from "../StepperFormExpediente";
import { autoFillReturn } from "../../../../helpers/autoFill";
import { MESA_ENTRADA_PERMISOS } from '../../../../utils/permisos';
import { dataProformaForm } from "../../data/datosProformaForm";
import { STEPPER_EXPEDIENTE_PROFORMA_FORM } from "../../../../utils/constants";

const useStyles = makeStyles({
  iconEstado: {
    "&:hover": {
      backgroundColor: "#80808026",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ProformaItem = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { item, onForm, setearVariosValores, resetForm, formValues } = props;
  const { tipoEfectorMenu, proformaTomada, recepcionMenu } = useSelector(state => state.mesaEntrada);
  const { dataContrato } = useSelector((state) => state.contrataciones);

  const nroSucursal = autoFillReturn(`${item?.comprobante.nroSucursal}`, 5);
  const nroFactura = autoFillReturn(`${item?.comprobante.nroFactura}`, 8);

  const handleSave = (formValues, handleClose) => {
    dispatch(postComprobanteMesaEntrada(formValues, handleClose));
  }

  return (
    <>
      <TableRow className={classes.iconEstado}>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={item?.estadoComprobante?.letra}
            backgroundColor={item?.estadoComprobante?.color}
            descripcion={item?.estadoComprobante?.descripcion}
          />
        </TableCell> 
        <TableCell align="center" >{item?.idExpediente}</TableCell>
        <TableCell align="center" >{nroSucursal}-{nroFactura}</TableCell>
        <TableCell align="center" >{item?.tramite.descripcion}</TableCell>
        <TableCell align="center" >{item?.destinoComprobantes.descripcion}</TableCell>
        <TableCell align="center" >
          {new Date(item?.comprobante.fechaInicioVigencia).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="center">
          {new Date(item?.comprobante.fechaFinVigencia).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="center">$ {parseFloat(item?.comprobante.totalComprobante).toFixed(2)}</TableCell>
        <TableCell>{item?.diagnostico?.problema}</TableCell>
        <TableCell align="center">
          {onForm ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              disabled={proformaTomada !== null ? true : false}
              onClick={() => {
                setearVariosValores({...dataProformaForm(item, tipoEfectorMenu, dataContrato?.idTipoFactura, recepcionMenu), idProforma: item.idExpediente });
                dispatch(tomarProformaMesaEntrada(item));
                dispatch(setActiveStepMesaEntrada(STEPPER_EXPEDIENTE_PROFORMA_FORM.DATOS_COMPROBANTE));
              }}
            >
              ASIGNAR PROFORMA
            </Button>
          ) : (
            <AddButtonComprobante 
              title="Agregar Asociación Proforma"
              handleSave={handleSave}
              permiso={MESA_ENTRADA_PERMISOS.ALTA}
              form={StepperFormExpediente}
              proforma={item}
            />
          )}
        </TableCell>
        {onForm && (
          <TableCell align="center">
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              disabled={formValues?.idProforma !== item?.idExpediente ? true : false}
              onClick={() => {
                resetForm();
                dispatch(liberarProformaMesaEntrada());
                dispatch(setActiveStepMesaEntrada(STEPPER_EXPEDIENTE_PROFORMA_FORM.TRAMITE_COMPROBANTE));
              }}
            >
              LIBERAR PROFORMA
            </Button>
          </TableCell>
        )}
      </TableRow>
    </>
  );
};
